// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31iOQ","input":"styles_input__3kFA3"};